// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.interntopbar-inline-1 {
  cursor: pointer;
  display: flex;
  align-items: center;
  position: relative;
}

.interntopbar-inline-2 {
  cursor: pointer;
}

.interntopbar-inline-3 {
  cursor: pointer;
}

.interntopbar-inline-4 {
  cursor: pointer;
}

.interntopbar-dyn-1 {
  position: absolute;
  top: var(--interntopbar-1-top);
  right: var(--interntopbar-1-right);
  background: #ef4444;
  color: #fff;
  border-radius: 10px;
  font-size: 9px;
  padding: 1px 5px;
  font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/Intern/InternTopbar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,kCAAkC;EAClC,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":[".interntopbar-inline-1 {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n\n.interntopbar-inline-2 {\n  cursor: pointer;\n}\n\n.interntopbar-inline-3 {\n  cursor: pointer;\n}\n\n.interntopbar-inline-4 {\n  cursor: pointer;\n}\n\n.interntopbar-dyn-1 {\n  position: absolute;\n  top: var(--interntopbar-1-top);\n  right: var(--interntopbar-1-right);\n  background: #ef4444;\n  color: #fff;\n  border-radius: 10px;\n  font-size: 9px;\n  padding: 1px 5px;\n  font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
